import React, { useEffect, useRef } from 'react';
import MG from 'metrics-graphics';
import 'metrics-graphics/dist/metricsgraphics.css';

export default (props) => {
  const target = useRef(null);
  const { params } = props;

  useEffect(() => {
    if (target.current === null) {
      return;
    }
    if (!params.data || !Array.isArray(params.data) || params.data.length === 0) {
      params.chart_type = 'missing-data';
    }
    MG.data_graphic({ target: target.current, ...params, transition_on_update: false });
  }, [target, params]);

  return (<div className="metricsGraphicsCon" ref={target} />);
};
